import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle, MonitorX, ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
export function ProblemSection() {
  const problems = [{
    icon: <MonitorX className="w-8 h-8 text-white" data-id="element-260" />,
    title: 'Te perdiste en la tecnología',
    desc: 'Te prometieron que era fácil, pero te pedían crear páginas web, usar herramientas que nunca habías visto, y te sentiste tonta por no entender.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-white" data-id="element-261" />,
    title: 'No hablaban tu idioma',
    desc: 'Cursos hechos por jóvenes que nunca han cuidado nietos ni trabajado limpiando casas. No entienden tu realidad ni tu ritmo.'
  }, {
    icon: <XCircle className="w-8 h-8 text-white" data-id="element-262" />,
    title: 'Te hicieron gastar antes de ganar',
    desc: 'Publicidad, software, inventario... gastaste dinero que no tenías antes de ver un solo centavo de vuelta.'
  }];
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-263">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-264"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-265">
        <div className="text-center mb-20" data-id="element-266">
          <span className="text-accent font-bold uppercase tracking-widest text-sm mb-4 block" data-id="element-267">
            ¿Te suena familiar?
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-268">
            Por qué los otros cursos te fallaron
          </h2>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto font-light" data-id="element-269">
            No es tu culpa. La mayoría de los cursos de "emprendimiento" ignoran
            la realidad de la mujer latina madura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-270">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="bg-brown-light/10 p-8 rounded-2xl border border-accent/30 text-center backdrop-blur-sm hover:border-accent/60 transition-colors" data-id="element-271">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/20 mb-6 border border-accent/30" data-id="element-272">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-273">
                {item.title}
              </h3>
              <p className="text-cream/80 leading-relaxed font-light" data-id="element-274">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-275">
          <Button variant="accent" onClick={scrollToOffer} className="glow-pink" data-id="element-276">
            Ver la solución que sí funciona
            <ArrowDown className="ml-2 w-5 h-5" data-id="element-277" />
          </Button>
        </div>
      </div>
    </section>;
}